import { Box } from '@mui/material';
import { AccessToken } from 'common-models';
import React, { useEffect } from 'react';
import { AuthContextProps, useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { OidcSigninState } from '../../@types/OidcSigninState';
import PageIsLoading from '../../components/PageIsLoading';
// import { setActiveCustomerId, setActiveUserId } from '../../services/AuthenticationService';


const getTargetUrl = (auth: AuthContextProps): string => {
    if (auth?.user?.state) {
        const signinState = auth?.user?.state as OidcSigninState;
        return signinState.targetUrl;
    }
    return "/";
}


interface SigninCallbackProps {
    accessToken: AccessToken;
}

const SigninCallback: React.FC<SigninCallbackProps> = (props) => {
    const auth = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.accessToken) {
            navigate(getTargetUrl(auth));
        }
    }, [props.accessToken, navigate])

    return (
        <Box>
            <Box>Signing you in, please wait...</Box>
            <PageIsLoading />
        </Box>
    )
};

export default SigninCallback;
